import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Transition as _Transition } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "order-position__recurring-order-head"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "order-position__info" }
const _hoisted_5 = {
  key: 1,
  class: "order-position__tags"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "order-position__tags",
  role: "note"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 4,
  class: "order-position__soldout-relation"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 5,
  class: "order-position__bottom"
}
const _hoisted_14 = { class: "order-position__price" }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = {
  key: 0,
  class: "order-position__price-old",
  "aria-hidden": "true"
}
const _hoisted_17 = { class: "order-position__qty" }
const _hoisted_18 = {
  key: 0,
  class: "product-order-position__loader loader"
}
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = {
  key: 2,
  class: "order-position__recurring-order"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["aria-label"]

import {defineAsyncComponent, computed, ref} from 'vue';
  import type BasketItem from '../../../bps/types/BasketItem';
  import ImageElement from '../../../bps/components/imageElement/imageElement.vue';
  import AvailabilityInfo from '../../../bps/components/availabilityInfo/availabilityInfo.vue';
  import pigeon from '../../../bps/utilities/js/pigeon/pigeon';
  import basketService from '../../../bps/services/basket/BasketService';
  import {t} from '@/bps/utilities/js/translations/translations';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'orderPosition',
  props: {
    item: {},
    disableQty: { type: Boolean, default: false },
    disableLink: { type: Boolean, default: true },
    showReduced: { type: Boolean, default: false },
    showTags: { type: Boolean, default: false },
    showFullInfo: { type: Boolean, default: false },
    isEditable: { type: Boolean, default: true }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

  const OrderPositionDeliverySelect = defineAsyncComponent(() => import('../../../bps/components/orderPosition/orderPositionDeliverySelect.vue'));

  const props = __props;

  const emit = __emit;

  const isLoading = ref(false);

  const qtyDisabled = computed(() => {
    return props.disableQty || props.item.freeItem || props.item.greetingCard || props.item.splittedId === '1';
  });

  const isBottle = computed(() => {
    return props.item.price.volumeUnit === 'BOTTLE';
  });

  function deleteItem() {
    emit('delete', props.item);

    if (props.item.freeItem) {
      pigeon.publish('productOrderFreeItem:remove', {product: props.item});
    } else if (props.item.splittedId != null) {
      changeQuantity(0);
    } else {
      isLoading.value = true;
      basketService.removeProduct(props.item, false).then(() => {
        isLoading.value = false;
      });
    }
  }

  async function changeQuantity(qty: number) {
    isLoading.value = true;
    await basketService.changeQuantityOfProduct(props.item, qty);
    isLoading.value = false;
  }

  function getPromotionTexts(): string[] {
    const result = [
      props.item.promotionData.favoriteWineText,
      props.item.promotionData.freeItemsBenefitConditionText,
      props.item.promotionData.freeItemsBenefitAppliedText
    ];

    return result.filter(text => !!text);
  }

  const milesAndMoreExcludeText = computed(() => {
    if (props.item.excludedFromEarn && props.item.excludedForSpent) {
      return t('checkout.basket.mm.excludeFromEarnSpend');
    }
    else if (props.item.excludedFromEarn) {
      return t('checkout.basket.mm.excludeFromEarn');
    }
    else if (props.item.excludedForSpent) {
      return t('checkout.basket.mm.excludeForSpend');
    }

    return '';
  });

return (_ctx: any,_cache: any) => {
  const _component_product_name = _resolveComponent("product-name")!
  const _component_counter_input = _resolveComponent("counter-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-position", {
      'order-position--unavailable': !_ctx.item.availability.available,
      'order-position--free-item': _ctx.item.freeItem,
      'order-position--recurring-order': _ctx.item.basketInfo && _ctx.showFullInfo,
      'order-position--high-current-price': _ctx.item.price.current.length > 7,
      'order-position--high-summary-price': _ctx.item.summaryPrice.length > 8
    }]),
    "aria-label": `${_ctx.item.counter.preselectedQuantity}× ${_ctx.item.name} ${_ctx.item.summaryPrice}`
  }, [
    (_ctx.item.basketInfo && _ctx.showFullInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('checkout.basket.position.recurringOrderItem.head')), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _cache[13] || (_cache[13] = _createTextVNode()),
    (_ctx.showReduced && _ctx.item.price.savedPercentage && _ctx.item.price.savedPercentage < 100 && !_ctx.item.freeItem)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "order-position__reduced-flag",
          role: "note",
          "aria-label": `-${_ctx.item.price.savedPercentage}%`
        }, _toDisplayString(_ctx.item.price.savedPercentage), 9 /* TEXT, PROPS */, _hoisted_3))
      : _createCommentVNode("v-if", true),
    _cache[14] || (_cache[14] = _createTextVNode()),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.disableLink ? 'span' : 'a'), {
      href: _ctx.disableLink ? null : _ctx.item.url,
      class: "order-position__image-container",
      "aria-hidden": "true"
    }, {
      default: _withCtx(() => [
        _createVNode(ImageElement, {
          class: _normalizeClass(["order-position__image", {
          'product-image--shadow-bottle': isBottle.value
        }]),
          "img-class": "order-position__image",
          "src-mobile": [_ctx.item.imageUrlMobile],
          src: [_ctx.item.imageUrl],
          alt: _ctx.item.name,
          webp: true
        }, null, 8 /* PROPS */, ["class", "src-mobile", "src", "alt"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href"])),
    _cache[15] || (_cache[15] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_product_name, {
        "product-clickable": !_ctx.disableLink,
        product: _ctx.item,
        class: _normalizeClass(["order-position__name", {
          'order-position__info--disabled': !_ctx.item.availability.available
        }])
      }, null, 8 /* PROPS */, ["product-clickable", "product", "class"]),
      _cache[7] || (_cache[7] = _createTextVNode()),
      (_ctx.item.greetingTextCardType !== 'OFF' && _ctx.showTags)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["order-position__greeting-text", {
          'order-position__info--disabled': !_ctx.item.availability.available
        }])
          }, _toDisplayString(_ctx.$t('checkout.basket.position.greetingtext.' + _ctx.item.greetingTextCardType)), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _cache[8] || (_cache[8] = _createTextVNode()),
      _createVNode(AvailabilityInfo, {
        class: "order-position__availability",
        availability: _ctx.item.availability
      }, null, 8 /* PROPS */, ["availability"]),
      _cache[9] || (_cache[9] = _createTextVNode()),
      ((_ctx.showTags && (getPromotionTexts().length || _ctx.item.numberDeliveredInBox)) || _ctx.item.freeItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPromotionTexts(), (promotionTextItem, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "order-position__promotion order-position__promotion--generic",
                key: index,
                innerHTML: promotionTextItem,
                role: "note"
              }, null, 8 /* PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */)),
            _cache[1] || (_cache[1] = _createTextVNode()),
            (_ctx.item.freeItem)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "order-position__promotion order-position__promotion--free-item",
                  innerHTML: _ctx.$t('checkout.basket.freeItem.label'),
                  role: "note"
                }, null, 8 /* PROPS */, _hoisted_7))
              : _createCommentVNode("v-if", true),
            _cache[2] || (_cache[2] = _createTextVNode()),
            (_ctx.item.numberDeliveredInBox)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "order-position__promotion order-position__promotion--in-box",
                  innerHTML: _ctx.$t('basket.position.numberDeliveredInBox', [_ctx.item.numberDeliveredInBox]),
                  role: "note"
                }, null, 8 /* PROPS */, _hoisted_8))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _cache[10] || (_cache[10] = _createTextVNode()),
      (_ctx.showTags && milesAndMoreExcludeText.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", {
              class: "order-position__promotion order-position__promotion--miles-and-more",
              innerHTML: milesAndMoreExcludeText.value
            }, null, 8 /* PROPS */, _hoisted_10)
          ]))
        : _createCommentVNode("v-if", true),
      _cache[11] || (_cache[11] = _createTextVNode()),
      (_ctx.showFullInfo && _ctx.item.deliveryMode)
        ? (_openBlock(), _createBlock(_unref(OrderPositionDeliverySelect), {
            key: 3,
            item: _ctx.item,
            disabled: qtyDisabled.value || !_ctx.isEditable
          }, null, 8 /* PROPS */, ["item", "disabled"]))
        : _createCommentVNode("v-if", true),
      _cache[12] || (_cache[12] = _createTextVNode()),
      (_ctx.item.soldoutRelation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("a", {
              class: "order-position__relation-btn",
              href: _ctx.item.soldoutRelation.url
            }, _toDisplayString(_ctx.$t('ads.ads_top_info.go_to.' + _ctx.item.soldoutRelation.type)), 9 /* TEXT, PROPS */, _hoisted_12)
          ]))
        : (_ctx.item.availability.available)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", {
                  class: _normalizeClass(["order-position__price-current", {'order-position__price-current--discount': _ctx.item.price.old}]),
                  "aria-label": _ctx.$t('checkout.basket.position.header.price')
                }, _toDisplayString(_ctx.item.price.current), 11 /* TEXT, CLASS, PROPS */, _hoisted_15),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (_ctx.item.price.old)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.item.price.old), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _cache[5] || (_cache[5] = _createTextVNode()),
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_counter_input, {
                  counter: _ctx.item.counter,
                  "disable-input-edit": qtyDisabled.value || !_ctx.isEditable,
                  onUpdate: _cache[0] || (_cache[0] = ($event: any) => (changeQuantity($event)))
                }, null, 8 /* PROPS */, ["counter", "disable-input-edit"]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createVNode(_Transition, { name: "vue-animation--fade-delayed" }, {
                  default: _withCtx(() => [
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("span", {
                class: "order-position__price-summary",
                "aria-label": _ctx.$t('checkout.basket.position.header.sum')
              }, _toDisplayString(_ctx.item.summaryPrice), 9 /* TEXT, PROPS */, _hoisted_19)
            ]))
          : _createCommentVNode("v-if", true)
    ]),
    _cache[16] || (_cache[16] = _createTextVNode()),
    (_ctx.showFullInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_ctx.item.basketInfo)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["order-position__product-info", {
          'order-position__info--disabled': !_ctx.item.availability.available
        }]),
                innerHTML: _ctx.item.basketInfo
              }, null, 10 /* CLASS, PROPS */, _hoisted_21))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _cache[17] || (_cache[17] = _createTextVNode()),
    (_ctx.isEditable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "order-position__delete-btn",
          onClick: deleteItem,
          type: "button",
          "aria-label": _ctx.$t('checkout.basket.removePosition')
        }, null, 8 /* PROPS */, _hoisted_22))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})